<template>
  <modal @close="closeModal">
      <h3>Choose Date Range</h3>
      <div class="large-form">            
          <div class="form-line">
              <div class="form-line">
                  <div class="form-field"  style="width: 50%">
                      <label>Starting Date</label>
                      <input type="date" v-model="item.dateStart">
                  </div>
                  <div class="form-field"  style="width: 50%">
                      <label>Ending Date</label>
                      <input type="date" v-model="item.dateEnd">
                  </div>
              </div>
          </div>
          <div class="modal-errors">
              <p v-for="e in errors" class="form-field error-text">{{ e[0] }}</p>
          </div>
      </div>
      <div class="form-actions">
          <div class="ws-button ws-button-main" @click="setRange">Continue</div>
          <div class="ws-button ws-button-secondary" data-action="cancel" @click="closeModal">Go Back</div>
      </div>
  </modal>
</template>


<script>
import Modal from "@/components/modals/Modal";

export default {
    name: "DateRangeModal",
    components: {Modal},
    props: {

    },
    data() {
        return {
            item: {
              dateStart: null, dateEnd: null,
            },
            errors: {},
        }
    },
    methods: {
      setRange() {
          this.$emit('set', this.item);
      },
      setDefaults() {
        const now = new Date();
        const monthAgo = new Date();
        monthAgo.setMonth(monthAgo.getMonth() - 1);
        this.item.dateStart = monthAgo.toISOString().split('T')[0];
        this.item.dateEnd = now.toISOString().split('T')[0];
      },
      closeModal() {
          this.$emit('close');
          modals.dateRangeModal = false;
      }
    },
    async mounted() {
      this.setDefaults();
    },
    computed: {
        modals() {
            return this.$store.state.modals;
        },
    }
}
</script>

<style scoped>

</style>